import { DataBean } from "../../DataBean";


export class ImpRut extends DataBean {

    public async importRUT(idEmployee: any, media: any, mediaContext: any): Promise<any> {
        return this.getCustomService("CacheOptions", "com.advantage.shared.Report_importRUT_Number_String_String", [idEmployee, media, mediaContext]);
    }

}